import {
    ReactNode, useCallback, useMemo,
} from 'react';
import { useReduxForm } from '@rainbow-modules/hooks';
import { PicklistValue } from '@rainbow-modules/listview/lib/components/AuditLogs/types';
import { Option } from 'react-rainbow-components';
import Picklist from 'components/Picklist';

interface SexPickerProps {
    id?: string;
    className?: string;
    name?: string;
    label?: string;
    tabIndex?: number | string;
    placeholder?: string;
    error?: ReactNode;
    required?: boolean;
    value?: string;
    onChange?: (value: string) => void;
}

const options = [
    { name: 'male', label: 'Male', value: 'male' },
    { name: 'female', label: 'Female', value: 'female' },
    { name: 'intersex', label: 'Intersex', value: 'intersex' },
    { name: 'unknown', label: 'Prefer Not to Say', value: 'unknown' },
];

const SexPicker = (props: SexPickerProps) => {
    const {
        value: valueInProps,
        onChange = () => {},
        id,
        className,
        name,
        label,
        tabIndex,
        placeholder,
        error,
        required,
    } = useReduxForm(props);

    const pickListvalue = useMemo(() => {
        if (!valueInProps) return undefined;
        return options.find((option) => option.value === valueInProps);
    }, [valueInProps]);

    const handleOnChange = useCallback(
        (value: PicklistValue) => onChange(value.value),
        [onChange],
    );

    const pickListOptions = useMemo(
        () => options.map((option) => <Option key={`sex-picker-option__${option.name}`} {...option} />),
        [],
    );

    return (
        <Picklist
            id={id}
            name={name}
            className={className}
            label={label}
            labelAlignment="left"
            tabIndex={tabIndex}
            required={required}
            placeholder={placeholder}
            value={pickListvalue}
            onChange={handleOnChange}
            error={error}
        >
            <Option label="Sex" variant="header" />
            {pickListOptions}
        </Picklist>
    );
};

export default SexPicker;
